import {flow, get} from 'lodash/fp';
import {createSelector} from 'reselect';

import {earningsById, performanceById} from './coach.selector';

export const frontlineQualifyingVolumeById = createSelector(
  performanceById,
  get('frontline.volumeThisMonth'),
);

export const generation0VolumeById = createSelector(
  performanceById,
  get('gen0.volumeThisMonth'),
);

export const totalGenerationVolumeById = createSelector(
  performanceById,
  get('totalGeneration.volumeThisMonth'),
);

export const orderingEntitiesById = createSelector(
  performanceById,
  flow([get('orderingEntitiesCount'), parseInt]),
);

export const qualifyingPointsById = createSelector(
  performanceById,
  flow([get('qualifyingPoints'), parseInt]),
);

export const bonusesLastMonthById = createSelector(
  earningsById,
  flow([get('bonusesLastMonth.amount'), parseFloat]),
);

export const bonusesLastMonthDeltaById = createSelector(
  earningsById,
  flow([get('bonusesLastMonth.changePercentage'), parseFloat]),
);

export const commissionLastWeekById = createSelector(
  earningsById,
  flow([get('commissionLastWeek.amount'), parseFloat]),
);

export const commissionLastWeekDeltaById = createSelector(
  earningsById,
  flow([get('commissionLastWeek.changePercentage'), parseFloat]),
);

export const incomeLastMonthById = createSelector(
  earningsById,
  flow([get('incomeLastMonth.amount'), parseFloat]),
);

export const incomeLastMonthDeltaById = createSelector(
  earningsById,
  flow([get('incomeLastMonth.changePercentage'), parseInt]),
);
